import { __GetContentTypeConfigNew } from "@/utils/getters/gettersV2";
import { useGetQueryData } from "@/utils/react-query-hooks/general";
import { useLocation } from "react-router-dom";

export const useShouldHideBorderBottom = () => {
  const location = useLocation();
  const { SELF_MANAGED_BASE_CONFIGS } = useGetQueryData('platformConfigs');
  
  // Check if we're on a route that renders CoverSection (ListingPage) or HomeCover
  const pathname = location.pathname;
  
  // Routes that render CoverSection (ListingPage)
  const listingPageRoutes = [
    '/edit/',
    '/moderate/',
    '/community-listing/',
    '/published-page/',
  ];
  
  // Routes that render HomeCover
  const homeCoverRoutes = [
    '/',
    '/home'
  ];
  
  const isPublishedListing = pathname.startsWith('/published-listing/');
  
  const isListingPage = listingPageRoutes.some(route => pathname.startsWith(route));
  const isHomeCover = homeCoverRoutes.some(route => pathname === route);
  
  if (isPublishedListing) {
    const contentType = pathname.split('/')[2]; // Extract content type from URL
    const contentTypeConfig = __GetContentTypeConfigNew(contentType);
    
    // Check if data pivot or overview dashboard is enabled (this determines if tabOptions exists)
    const hasDataPivot = SELF_MANAGED_BASE_CONFIGS?.listingConfig?.dataPivot?.enable ||
                        contentTypeConfig?.listing?.dataPivot?.enable;
    const hasOverviewDashboard = SELF_MANAGED_BASE_CONFIGS?.listingConfig?.overviewDashboard?.enable ||
                                contentTypeConfig?.listing?.overviewDashboard?.enable;
    
    // If there are no additional tabs (only "Documents"), hide the border
    // If there are additional tabs (data pivot or overview dashboard), show the border
    return !hasDataPivot && !hasOverviewDashboard;
  }
  
  return isListingPage || isHomeCover;
};